<template>
    <f7-page>
        <f7-navbar title="KHÔNG TÌM THẤY TRANG" backLink="Trở lại"></f7-navbar>
        <f7-block strong>
            <p>XIN LỖI</p>
            <p>KHÔNG TÌM THẤY TRANG</p>
        </f7-block>
    </f7-page>
</template>

<script>
export default {};
</script>
